import {
  calendarColorResolved,
  defaultEntryColor,
  kindColor,
  topicColorResolved,
  type Calendar,
  type ThemeConfig,
  type Topic,
} from "@app/core";
import { mixColors } from "./task-colors.js";

/** Calendars draw their auto fallback from the second half of the palette so a
 *  calendar and a topic at the same ordinal don't land on the same color. */
export const CAL_PALETTE_OFFSET = 6;

export function resolvedTopicColor(theme: ThemeConfig, topics: readonly Topic[], topicId: string): string | null {
  const i = topics.findIndex((topic) => topic.id === topicId);
  return i >= 0 ? topicColorResolved(theme, topicId, i) : null;
}

export function resolvedTopicColors(theme: ThemeConfig, topics: readonly Topic[], topicIds: readonly string[]): string[] {
  return topicIds
    .map((topicId) => resolvedTopicColor(theme, topics, topicId))
    .filter((color): color is string => !!color);
}

export function resolvedCalendarColor(
  theme: ThemeConfig,
  calendars: readonly Calendar[],
  calendarId: string | null | undefined,
): string | null {
  if (!calendarId) return null;
  const override = theme.entity.calendars?.[calendarId];
  if (override) return override;
  if (!theme.autoColorCalendars) return null;
  const i = calendars.findIndex((calendar) => calendar.id === calendarId);
  return i >= 0 ? calendarColorResolved(theme, calendarId, CAL_PALETTE_OFFSET + i) : null;
}

export function resolvedTaskContextColor(
  theme: ThemeConfig,
  topics: readonly Topic[],
  calendars: readonly Calendar[],
  task: { calendar_id: string | null; topic_ids: string[]; is_event?: boolean },
): string {
  const topicMix = mixColors(resolvedTopicColors(theme, topics, task.topic_ids));
  if (topicMix) return topicMix;
  const calendar = resolvedCalendarColor(theme, calendars, task.calendar_id);
  if (calendar) return calendar;
  return kindColor(theme, !!task.is_event) ?? defaultEntryColor(theme);
}
